import type { HeadingType } from '@Types/Shared/Heading';

import { Button } from '@Shared/Button/Button';
import Heading from '@Shared/Heading/Heading';

import type { CardTeamsType, TeamsTypeFront } from '@/_types/Blocks/Teams';
import type { QueryPost } from '@/_types/Shared/Query';

import InfosCard from '../components/Infos';

export default function TeamsHorizontal(props: TeamsTypeFront) {
	const {
		id,
		title,
		titleFormat,
		description,
		posts,
		imgType,
		containerType,
		headingAlign,
		archiveLink,
		linkIndex,
		headingFontClassName,
		contentFontClass,
		context,
		archiveLinkStyles,
		displayTags,
		displayDesc,
		displayMail,
		displayPhone,
		displaySocials,
		sectionDecoration,
	} = props;

	const headingProps: HeadingType = {
		title: title,
		description: description,
		titleFormat: titleFormat,
		headingAlign: headingAlign,
		headingFontClassName: headingFontClassName,
		context: context,
	};

	let blockStyle = '';
	if (containerType === 'block') {
		blockStyle =
			'desktop:p-12 tablet:p-6 p-5 bg-minos-teams-bg-container-color border-2 border-minos-teams-container-border-color rounded-minos-teams-container';
	} else {
		blockStyle = '';
	}

	let padding = '';
	if (sectionDecoration?.isSectionDecorated && sectionDecoration.type === 'wave') {
		padding = 'pt-12 pb-16 tablet:pt-12 tablet:pb-24 desktop:pt-24 desktop:pb-40';
	} else {
		padding = 'py-5 tablet:py-12 desktop:py-24';
	}

	return (
		<div id={id} className={`minos-grid relative bg-minos-teams-bg-color ${padding}`}>
			<div data-aos='fade-up' className={`relative z-[11] col-start-2 col-end-14 ${blockStyle}`}>
				<Heading {...headingProps} />

				{posts && (
					<div className='grid grid-cols-4 gap-y-5 tablet:grid-cols-12 tablet:gap-8'>
						{posts.map((post: QueryPost) => {
							return (
								<CardClassicTeams
									key={post.ID}
									post={post}
									contentFontClass={contentFontClass}
									imgType={imgType}
									displayTags={displayTags}
									displayDesc={displayDesc}
									displayMail={displayMail}
									displayPhone={displayPhone}
									displaySocials={displaySocials}
								/>
							);
						})}
					</div>
				)}

				<div className='m-auto mt-5 block w-fit'>
					{archiveLink && archiveLink.show && linkIndex ? (
						<Button
							label={archiveLink.label}
							url={linkIndex}
							style={archiveLink.type}
							urlType={'link'}
							urlOpenNewTab={archiveLink.target}
							btnHasIcon={archiveLinkStyles?.btnHasIcon}
							btnDecorationElement={archiveLinkStyles?.btnDecorationElement}
							primaryClassname='minos-events-btn-archivelink tablet:minos-events-btn-archivelink'
							animation={archiveLinkStyles?.animation}
						/>
					) : (
						''
					)}
				</div>
			</div>
		</div>
	);
}

export const CardClassicTeams = (props: CardTeamsType) => {
	const {
		post,
		imgType,
		contentFontClass,
		displayTags,
		displayDesc,
		displayMail,
		displayPhone,
		displaySocials,
		single,
	} = props;

	let imgStyle = '';
	if (imgType === 'roundedFull') {
		imgStyle = 'rounded-full';
	} else {
		imgStyle = 'rounded-minos-teams-img';
	}

	let cardclass =
		'tablet:col-span-6 tablet:odd:col-start-1 tablet:even:col-start-7 desktop:col-span-5 desktop:odd:col-start-2 desktop:even:col-start-7';

	if (single) {
		cardclass = 'tablet:col-span-6 tablet:col-start-4';
	}

	return (
		<div className={`${cardclass} col-span-full flex flex-col gap-y-4`}>
			{post.image?.url && (
				<div className='mx-auto block size-48'>
					<img
						className={`${imgStyle} aspect-square h-full object-cover`}
						src={post.image?.url}
						alt={post.post_title}
					/>
				</div>
			)}

			<h3 className={`mt-2 text-center ${contentFontClass?.teamsTitle}`}>
				{post.lastname || post.firstname ? (
					<>
						{post.lastname} {post.firstname}
					</>
				) : (
					<>{post.post_title}</>
				)}
			</h3>

			{displayTags && (
				<div className={`flex flex-wrap justify-center gap-1 ${contentFontClass?.teamsFunctions}`}>
					{post.tag?.length ? (
						<>
							{post.tag?.map((tag: string, index: number) => (
								<span key={index}> {(index ? '· ' : '') + tag} </span>
							))}
						</>
					) : (
						''
					)}
				</div>
			)}

			{displayMail || displayPhone || displaySocials ? (
				<div className={`flex flex-wrap justify-center gap-4 ${contentFontClass?.teamsInfos}`}>
					<InfosCard
						displayMail={displayMail}
						displayPhone={displayPhone}
						displaySocials={displaySocials}
						socials={post.socials}
						emailInfos={post.emailInfos}
						phoneInfos={post.phoneInfos}
					/>
				</div>
			) : (
				''
			)}

			{displayDesc && <p className={`${contentFontClass?.teamsExcerpt}`}>{post.content}</p>}
		</div>
	);
};
